export default function initInputs() {
    document.querySelectorAll(".anim-label").forEach(startAnimLabel);
}

function startAnimLabel(inputGroup) {
    if (inputGroup.classList.contains("anim-label--started")) return;
    inputGroup.classList.add("anim-label--started");

    const input = inputGroup.querySelector("input, textarea");
    const label = inputGroup.querySelector("label");

    if (input && label) {
        input.addEventListener("input", () => {
            if (input.value) {
                label.classList.add("active");
            } else {
                label.classList.remove("active");
            }
        });
    }
}

export function forceHTML5Validation() {
    document.querySelectorAll(":where(form, input, textarea):not(.novalidate)").forEach((el) => {
        el.removeAttribute("novalidate");
    });
}
